var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFstXtz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stXTZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "60.0005631 13.507835 100.265658 36.7548123 100.265658 83.2487316 60.0005631 106.495567 19.7355392 83.2487316 19.7355392 36.7548123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00B4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBF4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stXTZ",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.385692,31.4871635 L59.9998872,2.97433393 L10.6143084,31.487167 L10.6143084,88.5129442 L59.9998872,117.025669 L109.385692,88.5129476 L109.385692,31.4871635 Z M59.9983389,8.92022235 L104.231645,34.4600072 L104.231645,85.5360352 L59.9983389,111.07582 L15.7650324,85.5360352 L15.7650324,34.4600072 L59.9983389,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.961531,27.1132505 L64.9998858,2.88674493 C61.9058739,1.10042088 58.0938966,1.10042456 54.9998881,2.88675458 L13.0384522,27.1132473 C9.94444553,28.8995763 8.03845943,32.2008442 8.03845943,35.7734972 L8.03845943,84.2266046 C8.03845943,87.7992634 9.94445167,91.1005357 13.0384663,92.8868626 L54.9999028,117.113265 C58.0939038,118.899584 61.9058668,118.899588 64.9998714,117.113275 L106.961516,92.8868662 C110.055541,91.100542 111.961541,87.7992641 111.961541,84.2265981 L111.961541,35.77351 C111.961541,32.2008502 110.055547,28.899577 106.961531,27.1132505 Z M59.9998902,5.94866785 L106.809843,32.9743327 L106.809843,87.0257757 L59.9998902,114.051338 L13.1901574,87.0257757 L13.1901574,32.9743327 L59.9998902,5.94866785 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0005986,108.942672 C87.0300566,108.942672 108.941641,87.0310884 108.941641,60.0016303 C108.941641,32.9723493 87.0300566,11.0607297 60.0005986,11.0607297 C32.9711759,11.0607297 11.0595564,32.9723493 11.0595564,60.0016303 C11.0595564,87.0310884 32.9711759,108.942672 60.0005986,108.942672 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    fill: "url(#linearGradient-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.6404, 31.665)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.81351,3.95332522 C41.5997201,3.82287116 40.3670238,3.75669881 39.1192023,3.75669881 C20.1390819,3.75669881 4.69823681,19.1975439 4.69823681,38.1757737 C4.69823681,40.5012591 4.93078535,42.7738066 5.37319477,44.9707286 C1.99273304,40.302742 0,34.5627634 0,28.3595783 C0,12.6975285 12.6975285,-3.53520918e-15 28.3595783,-3.53520918e-15 C33.6382411,-3.53520918e-15 38.5803703,1.44255722 42.81351,3.95332522 Z M46.3868169,6.46598385 C44.048097,5.93093314 41.6167358,5.64733736 39.1192023,5.64733736 C21.1827144,5.64733736 6.58887536,20.2392857 6.58887536,38.1757737 C6.58887536,41.7131584 7.15606692,45.1200891 8.20537132,48.311487 C10.1413852,50.2664072 12.3609949,51.941513 14.7961373,53.2725225 C13.8130053,50.1435157 13.2836265,46.8178825 13.2836265,43.3693578 C13.2836265,25.1114613 28.1383736,10.2567142 46.3981607,10.2567142 C47.7480767,10.2567142 49.0790862,10.3380116 50.3855174,10.4949346 C49.1906339,9.02401782 47.8501711,7.67221125 46.3868169,6.46598385 L46.3868169,6.46598385 Z M54.9533002,18.4866638 C54.4882031,17.2331704 53.9361367,16.0231617 53.3046634,14.860419 C51.088835,14.3234777 48.776584,14.0379913 46.3981607,14.0379913 C30.2237479,14.0379913 17.0649036,27.1968356 17.0649036,43.3693578 C17.0649036,47.6346384 17.9799726,51.6900581 19.6248282,55.3484437 C21.8633442,56.0725582 24.2228611,56.5263115 26.6674568,56.67 C25.9225452,54.0590282 25.5236205,51.3024771 25.5236205,48.4532848 C25.5236205,32.1068239 38.6767929,18.7759315 54.9533002,18.4866638 L54.9533002,18.4866638 Z M56.4109825,24.1699233 C56.1065897,24.1585794 55.8021969,24.1529075 55.4959135,24.1529075 C42.096958,24.1529075 31.1955361,35.0543294 31.1955361,48.4532848 C31.1955361,51.2400861 31.6663051,53.9172303 32.5341082,56.4128732 C46.2166594,54.3955618 56.7191566,42.6036492 56.7191566,28.3595783 C56.7191566,26.9359275 56.6151715,25.5368549 56.4109825,24.1699233 L56.4109825,24.1699233 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFstXtz);
export default __webpack_public_path__ + "static/media/fstXTZ.8c8be844c690f186d62211f713ae8013.svg";
export { ForwardRef as ReactComponent };